import { Spacing, getGapClassName } from '../spacing';
import { getKDSClasses, merge } from '../util';
import { useIsFixedHeightRow } from './FixedHeight/FixedHeightRowContext';

export interface ColumnProps {
  children?: any;
  gap: Spacing;
}

export const Column = (props: ColumnProps) => {
  const { children, gap } = props;

  const gapClassName = getGapClassName(gap);

  const grow = useIsFixedHeightRow();

  return (
    <div
      className={merge(
        getKDSClasses('grid-column'),
        'flex flex-col relative',
        gapClassName,
        grow ? 'flex-grow' : ''
      )}
    >
      {children}
    </div>
  );
};
